/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthCodeUser
 */
export interface OAuthCodeUser {
    /**
     * 
     * @type {string}
     * @memberof OAuthCodeUser
     */
    id: string;
}

/**
 * Check if a given object implements the OAuthCodeUser interface.
 */
export function instanceOfOAuthCodeUser(value: object): value is OAuthCodeUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OAuthCodeUserFromJSON(json: any): OAuthCodeUser {
    return OAuthCodeUserFromJSONTyped(json, false);
}

export function OAuthCodeUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthCodeUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function OAuthCodeUserToJSON(json: any): OAuthCodeUser {
    return OAuthCodeUserToJSONTyped(json, false);
}

export function OAuthCodeUserToJSONTyped(value?: OAuthCodeUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

